import { render, staticRenderFns } from "./TrainingTiles.vue?vue&type=template&id=2c0d143e"
import script from "./TrainingTiles.vue?vue&type=script&lang=js"
export * from "./TrainingTiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports